export const newDeviceCodeMessageTemplate =
  $localize`Hi` + ` *|GUEST:NAME|*<br><br> ` + $localize`New code is generated for Device` + ` *|DEVICE:NAME|*`
